export const communityMemberOptionMap = member => ({
  key: member.organisationId,
  value: member.organisationId,
  text: member.organisationName,
});
